import './header.scss';

import { NetworkError, useSuspense } from '@data-client/react';
import React, { useCallback } from 'react';

import { AccountDashboardTypeResource } from '@datarock/api-client';
import AsyncBoundary from '../AsyncBoundary';
import { DOMAIN } from '../../consts';
import Dropdown from 'react-bootstrap/Dropdown';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Spinner } from 'react-bootstrap';
import { SignOutPath } from '../../routing';
import { faUserCircle } from '@fortawesome/free-regular-svg-icons';
import strings from '../../strings';
import { useAuth } from 'oidc-react';
import { useHistory } from 'react-router-dom';

import profileStyles from './Profile.module.scss';

function ErrorFallback({ error }: { error: NetworkError }) {
  return <>{error.message}</>;
}

function LoadingFallback() {
  return (
    <div className="dropdown-wrapper">
      <div
        className={`dropdown-toggle btn ${profileStyles.profileLoadingSlot}`}
        aria-busy="true"
        role="presentation">
        <span className={profileStyles.profileSpinnerWrap}>
          <Spinner animation="border" role="status" />
          <span className="visually-hidden">Loading...</span>
        </span>
      </div>
    </div>
  );
}

function Profile() {
  const auth = useAuth();
  const history = useHistory();

  const dashboardType = useSuspense(
    AccountDashboardTypeResource.get,
    auth.userData
      ? {
          accountId: auth.userData.profile.sub
        }
      : null
  );

  const onSignoutClick = useCallback(() => {
    history.push(SignOutPath);
  }, [history]);

  const onClick = useCallback(() => {
    if (process.env.REACT_APP_ADMIN_PORTAL_URL) {
      window.location.href = process.env.REACT_APP_ADMIN_PORTAL_URL;
    }
  }, []);

  if (!auth.userData) {
    return null;
  }

  const isShowGoToAdminPortalButton =
    DOMAIN === 'admin' || !dashboardType || dashboardType.type === 'USER';

  return (
    <Dropdown className="dropdown-wrapper">
      <Dropdown.Toggle>
        <FontAwesomeIcon
          icon={faUserCircle}
          style={{ width: 25, height: 25 }}
        />
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {!isShowGoToAdminPortalButton && (
          <Dropdown.Item onClick={onClick}>
            {strings.componentHeaderAdminButton}
          </Dropdown.Item>
        )}
        <Dropdown.Item onClick={onSignoutClick}>
          {strings.componentHeaderLogoutButton}
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
}

export default function ProfileWithSuspense() {
  return (
    <AsyncBoundary
      errorFallback={ErrorFallback}
      loadingFallback={LoadingFallback}>
      <Profile />
    </AsyncBoundary>
  );
}
